import {
    apiRequest,
    bankDetail
} from "../../../../../services/adapters/master/bankService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", bankDetail, {
            params: query
        }, true)
    }
}

export default DetailRepository